var _clipPath, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 30",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,15h30v15zv15h-30zh-30v-15zv-15h30z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0v30h60v-30z",
    fill: "#012169"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 60,30M60,0 0,30",
    stroke: "#fff",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 60,30M60,0 0,30",
    clipPath: "url(#t)",
    stroke: "#C8102E",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30,0v30M0,15h60",
    stroke: "#fff",
    strokeWidth: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30,0v30M0,15h60",
    stroke: "#C8102E",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.906cac8e2654c383f52578d15adbee31.svg";
export { ForwardRef as ReactComponent };